import React from "react";
import "./RightBarStyles.scss";
const RightBar = (props) => {
  return <div className="Rightbar" />;
};
export default RightBar;
